import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import LoginPage from './LoginPage';

import { setSignupSecondStep as setSignupSecondStepAction } from '../../actions/lookup';
import {
    clearAuthNotification as clearAuthNotificationAction,
    redirectToSignUp as redirectToSignUpAction,
    cleanSocialAuthenticationData as cleanSocialAuthenticationDataAction,
} from '../../actions/auth';
import { socialLogInUser as socialLogInUserAction } from '../../actions/social';
import {
    cancelToS as cancelToSAction,
    acceptSocialToS as acceptToSAction,
} from '../../actions/tos';

const _mapStateToProps = ({ authentication }) => ({
    socialSSOSettings: authentication.socialSSOSettings,
    launchAsyncStrategyForAuthSocialScripts:
        authentication.featureFlags.launchAsyncStrategyForAuthSocialScripts,
});
const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onSocialLogInUser: socialLogInUserAction,
    handleSignUpClick: redirectToSignUpAction,
    setSignupSecondStep: setSignupSecondStepAction,
    cancelToS: cancelToSAction,
    acceptSocialToS: acceptToSAction,
    cleanSocialAuthenticationData: cleanSocialAuthenticationDataAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(LoginPage),
);
